// got rid of geo fetching from client side

// to change the userid and userlevel for testing, it needs to be changed in 2 places startss as if (debug) ...
// 1) line 1025 - changes level
// 2) line 1060 - changes userid
// 3) line 1163 - changes level



import React, { useState, useLayoutEffect, useEffect } from "react"
import { getTodayDate, monthsOptionsList } from './Common'
import * as rdd from 'react-device-detect';
import DesktopLayout from './DesktopLayout'
import MobileLayoutP from './MobileLayoutP'
import MobileLayoutL from './MobileLayoutL'
import { BrowserView, MobileView } from 'react-device-detect';
import { UserContext } from './UserContext'


// import { flaskServerIP } from './Common'   // for login
import { freeYears, startingSecurity, startingSecurityName } from './Common' // for free users
import { incrementDate } from './Common'
import { debug } from './Common';
import { appserverURL, securities_groups_default_years } from './Common'
import { getSelectedIDFromSecuritiesList2 } from './Common'
import { trend_chart_left_gap_days } from './Common'
import { userAccessToSelectedSecurity } from './Common'

import { getCookie, setCookie } from './Common'
import jwt_decode from 'jwt-decode'
//-------------------- swiper -----------------------------
// Import Swiper styles
import "swiper/swiper.min.css";
import "swiper/components/pagination/pagination.min.css"
import "swiper/components/navigation/navigation.min.css"
// import Swiper core and required modules
import SwiperCore, { Pagination, Navigation, Virtual } from 'swiper/core';
// import { waitForElementToBeRemoved } from "@testing-library/react";
// install Swiper modules
SwiperCore.use([Pagination, Navigation, Virtual]);
//-------------------- swiper -----------------------------

const App = () => {


  // if (debug) userid = '1'; // this is Tidal Yearly 
  // if (debug) userid = '19'; // this is free Ripple 
  // if (debug) userid = testUserID; // this is for testing Free Ripple level only
  // if (debug) userid = '17'; // this is me - this is basic - 15 is premium

  // if (debug) userid = '16'; // this is me - this is free registered
  // if (debug) userid = '0'; // testing non loggedin user

  // assinged only when debug === true
  const testUserLevel = '9'; // '0' is not loggedin 1 is free Ripple 2 is splash_monthly 4 is yearly 5 is surf_monthly 6 is yearly tidal 8 and 9
  const testUserID = '1';    // userid=0 is not_loggedin userid = 19 has free explorer 1 is institutional yearly 

  //############################# parameters ##############################
  // const debug = true;   // set to true to use port 3000 debugging 
  // const { qstr } = useParams(); // this is to get the querystring in react 5/8/2023 - didn't work - using windows funcs instead


  //-------- set to false not to display the disclosure box in app start
  const [infoBoxVisible, SetInfoBoxVisible] = useState(false); //default of next 3 should be false
  const [helpBoxVisible, SetHelpBoxVisible] = useState(false);
  const [videosBoxVisible, SetVideosBoxVisible] = useState(false);
  const [reportsDashVisible, SetReportsDashVisible] = useState(false);

  const [dialogType, SetDialogType] = useState('terms-conditions');
  const [dialogProp, SetDialogProp] = useState({ title: 'init', contentText: 'none', button1Text: '', button2Text: 'Close', coverDivColor: 'rgb(222,222,222,0)' }) // this is used to pass properties for info-box dialog
  const [swiper, setSwiper] = useState(null);

  const [browserH, SetBrowserH] = useState(window.innerHeight)
  const [browserW, SetBrowserW] = useState(window.innerWidth)

  const [globalTextSize, SetGlobalTextSize] = useState('1vw') // use this throughout the app to display text on various devices
  const [checkboxZoom, SetCheckboxZoom] = useState('1')
  const [tableTextSize, SetTableTextSize] = useState('1vw');
  const [tableTitleTextSize, SetTableTitleTextSize] = useState('1vw');
  const [infoTextSize, SetInfoTextSize] = useState('1vw');

  // reactpress sizing modifications code
  const [seasonalAppDivH, setSeasonalAppDivH] = useState(0)   //dekstop app height with react press with header and footer
  const [seasonalAppDivH2, setSeasonalAppDivH2] = useState(0) //dekstop app height with react press without header and footer

  // console.log(rdd.isMobile, browserH, browserW)

  const [seasonalBarChartData, SetSeasonalBarChartData] = useState([])
  const [tradeDetailData, SetTradeDetailData] = useState([])
  const [consolidatedSeasonalData, SetConsolidatedSeasonalData] = useState([])
  const [janDecDateRange, SetJanDecDateRange] = useState(false);

  const [startDate, SetStartDate] = useState(getTodayDate());

  const [symbol, SetSymbol] = useState("");
  const [company, SetCompany] = useState("");
  const [daysOut, SetDaysOut] = useState("30");


  const [seasonalYears, SetSeasonalYears] = useState("10");
  const [monthsAndQtrs, SetMonthsAndQtrs] = useState('Months & Qtrs');

  const [oppTableLength, SetOppTableLength] = useState(0); // this is the number displayed in the bottom of opp table


  const [showMFE, setShowMFE] = useState(() => {
    let ret = true;
    let MFEdisp = getCookie('MFE');

    if (MFEdisp == null) ret = false; // default value
    else {
      if (MFEdisp === 'true') ret = true;
      else ret = false;
    }
    return ret;
  });
  const [showMAE, setShowMAE] = useState(() => {
    let ret = true;
    let MAEdisp = getCookie('MAE');

    if (MAEdisp == null) ret = false; // default value
    else {
      if (MAEdisp === 'true') ret = true;
      else ret = false;
    }
    return ret;
  });

  const [helpEmailDisplay, SetHelpEmailDisplay] = useState('none'); // css display value for help dialog

  const [barChartLongOrShort, SetBarChartLongOrShort] = useState('long')
  const [lineChartYear, SetLineChartYear] = useState(0)

  const [tradeActive, SetTradeActive] = useState(false) // true if the latest trade is active 
  const [tradeDate0, SetTradeDate0] = useState('') //current linechart date0
  const [tradeDate1, SetTradeDate1] = useState('') //current linechart date1

  const [lastPrice, SetLastPrice] = useState(['', 0]); // last stock price to be shown in VisualTableDesc.js

  const [token, SetToken] = useState('')

  const [securityTypeList, SetSecurityTypeList] = useState([])
  const [securityTypeList2, SetSecurityTypeList2] = useState([]) // 4/12/2022 new format - keeping

  const [selectedSecurity, SetSelectedSecurity] = useState(() => {
    // console.log('iiiiiiiiiinitialize setting selected security to blank')
    return '';
  });

  const [selectedSecurityType, SetSelectedSecurityType] = useState('F') //'F' or 'P' free or premium



  // 8/22/2021 moved it from oppTable 
  const [opportunities, SetOpportunities] = useState([])// opportinities table data
  const [activeOpportunities, SetActiveOpportunities] = useState([])// 5/2/2024
  const [showActiveOpps, SetShowActiveOpps] = useState(false); // 5/2/2024

  const [oppTableMonth, SetOppTableMonth] = useState(() => {
    var TodayDate = new Date();
    var isLeapDay = TodayDate.getMonth() === 1 && TodayDate.getDate() === 29;
    if (isLeapDay) return 'March'; // skipping feb 29th and going straight to march 1st
    // console.log('*******************************',monthsOptionsList[TodayDate.getMonth()]['value'])
    return (monthsOptionsList[TodayDate.getMonth()]['value'])
  })
  const [oppTableYears, SetOppTableYears] = useState("12")


  const [oppTablePartialYears, SetOppTablePartialYears] = useState(-1)


  const [appliedFilter, SetAppliedFilter] = useState('no filter')

  const [rowIndexClicked, SetRowIndexClicked] = useState(-1);

  // user data
  const [loggedinUser, SetLoggedinUser] = useState('0')
  const [wpUserLevels, SetWpUserLevels] = useState([0]) // level 0 is for non logged-in users


  const [userDateRange, SetUserDateRange] = useState([]) // mainly for level 1 week


  // had to move here because when mobile orientation chagnes, there was an undefined bug
  const [statBoxCoordinates, SetStatBoxCoordinates] = useState(['13%', '4.5%', '25%', '30%'])


  //-------------------------------------------------------------------------------------------------------
  // this is for the day of the month textbox
  const [dayOfTheMonth, SetDayOfTheMonth] = useState(parseInt(getTodayDate().substring(8, 10)).toString())
  const [daysOfMonthList, SetDaysOfMonthList] = useState([]) // 4/30/2022 switching opp day to pull down
  //---------------------------------------------------------------


  // const [userGeoData, SetUserGeoData] = useState({ 'error': '!', 'IPv4': '' })

  const [allowedSymbols, SetAllowedSymbols] = useState({})


  // tooltip on/off
  const [tooltipSW, SetTooltipSW] = useState(false)


  //4/12/2022 - 
  const [resourceObj, SetResourceObj] = useState({})



  const [userFreeResources, SetUserFreeResources] = useState([])
  const [userPremResources, SetUserPremResources] = useState([])
  // const [userNonLoggedResources, SetUserNonLoggedResources] = useState([])



  const [yearsMetaData, SetYearsMetaData] = useState([]) // get all years and partial years based on data 

  const [stockScoreCurrent, SetStockScoreCurrent] = useState(true) // toggle between historical and current stockscore.  when historical, use the start date set on seasonalviewer


  const [exportImage, SetExportImage] = useState(false)

  const [numReportsAllowed, SetNumReportsAllowed] = useState(0); // this is the number of reports a user is allowed to generate
  const [numReportsCreated, SetNumReportsCreated] = useState(-1); // -1 means it has been loaded yet
  const [numPortfoliosAllowed, SetNumPortfoliosAllowed] = useState(0);
  const [reportsList, SetReportsList] = useState([]);

  const [upgradeMessage, SetUpgradeMessage] = useState('') // this is the message that is displayed when user is free ripple to upgrade
  const [promotionMessage, SetPromotionMessage] = useState('') // this is the message that is displayed when user is free ripple and has promotions
  const [promotionCouponCode, SetPromotionCouponCode] = useState('') // this is the message that is displayed when user is free ripple and has promotions
  const [showUpgradeBanner, SetShowUpgradeBanner] = useState(false) // this is the switch to display the upgrade banner
  const [promotionBackColor, SetPromotionBackColor] = useState('orange')

  const [addGCVisible, SetAddGCVisible] = useState(false);
  const [googleCalendarDict, SetGoogleCalendarDict] = useState({});

  const [multiPortfolios, SetMultiPortfolios] = useState(true); // switch to turn multi portfolios on and off
  const [showPortfolioSettings, SetShowPortfolioSettings] = useState(false);

  const [showSettings, SetShowSettings] = useState(false);

  const [portfolios, SetPortfolios] = useState([]);

  const [selectedPortfolio, SetSelectedPortfolio] = useState(() => {

    let cookie = getCookie('selected_portfolio')

    if (cookie !== null) {
      return cookie.split(',')[1];
    }
    else return 'main';
  });
  const [selectedPortfolioID, SetSelectedPortfolioID] = useState(() => {
    let cookie = getCookie('selected_portfolio')

    if (cookie !== null) {
      return cookie.split(',')[0];
    }

    else return 0;
  });


  const [qparams, SetQparams] = useState(''); // this is used to know if the session started with passed parameter
  const [showOppNote, SetShowOppNote] = useState(false);

  // selectedNote and selectedDRID are used for updating the note for the opp
  const [selectedNote, SetSelectedNote] = useState('');
  const [selectedDRID, SetSelectedDRID] = useState('');
  const [selectedPortfolioRec, SetSelectedPortfolioRec] = useState('');

  // this is used for comparing the current security to another - by default its S&P500 index 9/9/2023

  const [compareSecurity, SetCompareSecurity] = useState([5, 'SPX', '01-01', 366]); // last 2 are start date and num days for S&p500 



  const [compareSecurityBarChartData, SetCompareSecurityBarChartData] = useState([]);
  const [compareSecurityTradeDetailData, SetCompareSecurityTradeDetailData] = useState([]);
  const [compareSecurityLongOrShort, SetCompareSecurityLongOrShort] = useState('long');

  const [securityBHstats, SetSecurityBHstats] = useState([]);

  const [reverseDateSelected, SetReverseDateSelected] = useState(false); // this flag is used by consolidatedSeasonalChart to set a better initial date for the reversed chart

  // this used for the start date and end date of the trend chart
  // its initially set to the current opportunity start date - 14 days
  // if date range is reversed its again set to the reversed opportunity start date - 14
  // it does not   
  const [trendChartStartDate, SetTrendChartStartDate] = useState('') // this used for the start date and end date of the trend chart

  const [initialWindowNum, SetInitialWindowNum] = useState(() => {
    let bottomWindowNumber = getCookie('WindowNumber');

    let queryString = window.location.search;
    if (queryString.length > 0 && queryString !== '?set=on') {
      bottomWindowNumber = 1;
    }

    if (bottomWindowNumber === null) return "1";
    return bottomWindowNumber;
  });

  // trim year is used to trim the oldest years for special years like odd, even, PE, PE1, PE2, PE3 - 
  // trimyear only effects those special years, regular years has no change by trim year
  const [trimYear, SetTrimYear] = useState(0); // used for setting the oldest year cut off - useful for cutting the 1928 ... in 95 year PE3 SPX for example

  const [autoTradePortfolioMonth, SetAutoTradePortfolioMonth] = useState('');

  // this is an array of display switches.  before everytime I created a new dialog I declared a new variable - now let's just use this as an array 11/18/2023
  // [0] = populate_portfolio dialog
  const [showPopulatePortfolio, SetShowPopulatePortfolio] = useState(false);
  const [showAutoTrade, SetShowAutoTrade] = useState(false);
  const [showTradeReport, SetShowTradeReport] = useState(false);

  const [showTradeInstrumentReport, SetShowTradeInstrumentReport] = useState(false);
  const [tradeInstrumentReportDict, SetTradeInstrumentReportDict] = useState({});

  const [showSR2, SetShowSR2] = useState(false); // this is to control the configuration of oppTable that display 2 additional columns for AP2 and SR2

  const [switchStreamingQuotes, SetSwitchStreamingQuotes] = useState(true); // this is to switch streaming quotes on and off
  const [switchStreamingAccount, SetSwitchStreamingAccount] = useState(true); // this is to switch streaming account on and off

  const [showWatermark, SetShowWatermark] = useState(false); // this is to show the watermark on the chart
  const [downloadImageName, SetDownloadImageName] = useState('initial.jpg');

  const [showChatbot, SetShowChatbot] = useState(false);

  // Used to manually trigger a refresh of the useEffect below.
  // Every time we increment refreshKey, the effect re-runs.
  // This is useful when external actions need to force a re-load or re-fetch,
  // even if dependencies haven't naturally changed.
  const [refreshKey, SetRefreshKey] = useState(0);

  // ########################################################################################################################################################
  // #################################################################### End Declerations ##################################################################
  // ########################################################################################################################################################

  //--------create list for day of the month selectbox 4/30/2022-----------------------------------------------------------------------------------------------

  const dayOfMonthList = (m) => {

    // now create SetDaysOfMonthList  4/30/2022
    // get current opp_date before increment 
    // let monthNum = 0;
    let lastDayOfMonth = '';
    for (let i = 0; i < monthsOptionsList.length; i++) {
      if (monthsOptionsList[i]['label'] === m) {
        lastDayOfMonth = parseInt(monthsOptionsList[i]['range'][1].split('-')[1]) // get last day from common

        // console.log('found=',monthsOptionsList[i]['label'] , oppTableMonth)
        break;

      }
    }

    // console.log('lastDayOfMonth=', lastDayOfMonth, props.oppTableMonth)


    // console.log('xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx',process.env.REACT_APP_HELP_VIDEOS)

    let tmp = []

    for (let i = 1; i <= lastDayOfMonth; i++) {
      tmp.push({ id: i, value: i.toString(), label: i.toString() })
    }
    SetDaysOfMonthList(tmp) // 4/30/2022 for use with day of the month pulldown
  }


  //-------------------------------------------------------------------------------------------------------

  //- increment decrement or set date to a new number - returns true if number has changed - otherwise false
  const incdecDay = (incnum, newnum) => {

    // get current opp_date before increment 
    var monthNum = 0;
    for (let i = 0; i < monthsOptionsList.length; i++) {
      if (monthsOptionsList[i]['label'] === oppTableMonth) {
        monthNum = monthsOptionsList[i]['id']; break;
      }
    }

    var tmp_dayOfTheMonth = parseInt(dayOfTheMonth)
    tmp_dayOfTheMonth = (tmp_dayOfTheMonth < 10 ? '0' : '') + tmp_dayOfTheMonth.toString()

    // console.log('dayofthemonth=', dayOfTheMonth, typeof (dayOfTheMonth))

    var opp_date = getTodayDate().substring(0, 4) + '-' + (monthNum < 10 ? '0' : '') + monthNum.toString() + '-' + tmp_dayOfTheMonth;
    var new_opp_date = incrementDate(opp_date, incnum)


    if (userDateRange.length === 2) { // this user has restrictions currenlty due to free registered.  
      if (new_opp_date < userDateRange[0] || new_opp_date > userDateRange[1]) {
        // this user does not have access to dates beyond userDateRange.  Show message
        // console.log('false')
        return false;
      }
    }

    // check if + or - was clicked at the first day or last days of the month
    // where month and day should change - change day and month for continuity
    if (opp_date.substring(5, 7) !== new_opp_date.substring(5, 7)) {

      var new_month_num = new_opp_date.substring(5, 7)
      new_month_num = parseInt(new_month_num)

      var newMonth = monthsOptionsList[new_month_num - 1].value
      var newDay = new_opp_date.substring(8, 10)

      SetDayOfTheMonth(parseInt(newDay))
      SetOppTableMonth(newMonth)
      dayOfMonthList(newMonth)  // 4/30/2022 - this is to create day of the month selectbox for opptable
      return true
    }


    let d = parseInt(dayOfTheMonth) // currently set dayofthemonth


    let orig_num = d;
    if (incnum !== 0) {
      d += incnum;
    }
    else {
      d = newnum
    }

    monthNum = 0;
    let range = []
    for (let i = 0; i < monthsOptionsList.length; i++) {
      if (monthsOptionsList[i]['label'] === oppTableMonth) {
        monthNum = monthsOptionsList[i]['id'];
        range = monthsOptionsList[i]['range']
        break;
      }
    }

    let maxMonthNum = parseInt(range[1].substring(3, 5))



    if (d > 0 && d <= maxMonthNum) {
      SetDayOfTheMonth(d)

      return true;
    }
    else {
      SetDayOfTheMonth(orig_num)
      return false;
    }
  }
  //---------------------------------------------------------------
  // this is event handler for increment and decrement of the day of the month 
  const dayIncrement = () => { // num should be 1 or -1


    if (loggedinUser === '0' || (wpUserLevels.length === 1 && wpUserLevels[0] === '1')) {  // removing the 1 week allowance for registered free
      SetDialogType('free-register')
      SetInfoBoxVisible(true);
      return;
    }


    // if selected security is Free, change the oppTable date to today
    let retArray = userAccessToSelectedSecurity(securityTypeList2, selectedSecurity)
    if (retArray[0] === 'F') {
      SetDialogType('free-register')
      SetInfoBoxVisible(true);
      return;
    }




    if (incdecDay(1, 0))
      SetOpportunities([]) //clear opportunties table becaues there will be a new fetch
  }
  //---------------------------------------------------------------
  const dayDecrement = () => { // num should be 1 or -1
    if (loggedinUser === '0' || (wpUserLevels.length === 1 && wpUserLevels[0] === '1')) {  // see above
      SetDialogType('free-register')
      SetInfoBoxVisible(true);
      return;
    }

    let retArray = userAccessToSelectedSecurity(securityTypeList2, selectedSecurity)
    if (retArray[0] === 'F') {
      SetDialogType('free-register')
      SetInfoBoxVisible(true);
      return;
    }


    if (incdecDay(-1, 0))
      SetOpportunities([]) //clear opportunties table becaues there will be a new fetch
  }
  //---------------------------------------------------------------
  const handleBlurInc = (event) => {
    // console.log('blur')
    if (loggedinUser === '0') {
      SetDialogType('free-register')
      SetInfoBoxVisible(true);
      return;
    }
    // if (wpUserLevels.length == 1 && wpUserLevels[0] == '1') return; //free registered can't type and press enter

    if (incdecDay(0, event.target.value)) // set to the number that was typed in
      SetOpportunities([]) //clear opportunties table becaues there will be a new fetch
  }
  //---------------------------------------------------------------
  const handleEnterInc = (event) => {
    if (event.key === 'Enter') {
      if (loggedinUser === '0') {
        SetDialogType('free-register')
        SetInfoBoxVisible(true);
        return;
      }
      // if (wpUserLevels.length == 1 && wpUserLevels[0] == '1') return; //free registered can't type and press enter

      if (incdecDay(0, event.target.value)) // set to the number that was typed in
        SetOpportunities([]) //clear opportunties table becaues there will be a new fetch
    }
  }
  //---------------------------------------------------------------
  const handleDayChange = (event) => {


    if (loggedinUser === '0') {
      SetDialogType('free-register')
      SetInfoBoxVisible(true);
      return;
    }
    if (wpUserLevels.length === 1 && wpUserLevels[0] === '1') return; //free registered can't type and press enter

    let retArray = userAccessToSelectedSecurity(securityTypeList2, selectedSecurity)
    if (retArray[0] === 'F') {
      SetDialogType('free-register')
      SetInfoBoxVisible(true);
      return;
    }

    if (incdecDay(0, event.target.value)) // set to the number that was typed in
      SetOpportunities([]) //clear opportunties table becaues there will be a new fetch
  }
  //---------------------------------------------------------------
  // this serves oppTable selectboxes
  //---------------------------------------------------------------
  const selectboxChanged = (event) => {

    // console.log('...........event.......... selectboxchanged   ')

    if (wpUserLevels.length === 1 && wpUserLevels[0] === '1' && event.target.id !== 'filter' && event.target.id !== 'years' && event.target.id !== 'partialYears' && event.target.id !== 'securityTypeList') { //free registered
      SetDialogType('free-register')
      SetInfoBoxVisible(true);
      return;
    }

    // 5/2/2024 turning off the active opps visible variable when these selectboxes change
    if (event.target.id === 'months' || event.target.id === 'day' || event.target.id === 'years' || event.target.id === 'partialYears') {
      SetShowActiveOpps(false); // 5/2/2024
    }


    if (event.target.id === 'months') {

      if (loggedinUser === '0') {
        SetDialogType('free-register')
        SetInfoBoxVisible(true);
        return;
      }

      // console.log('props.selectedSecurity=', selectedSecurity)
      // console.log('securityTypeList2=', securityTypeList2)

      // 4/13/2022 - check if the selected security is Free or Premium for this user
      let retArray = userAccessToSelectedSecurity(securityTypeList2, selectedSecurity)
      SetSelectedSecurityType(retArray[0])
      // console.log('rrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrretarray[0]=', retArray[0])

      if (retArray[0] === 'F') {
        SetDialogType('free-register')
        SetInfoBoxVisible(true);
        return;
      }

      SetOppTableMonth(event.target.value)
      dayOfMonthList(event.target.value)  // 4/30/2022 - this is to create day of the month selectbox for opptable
      SetDayOfTheMonth('1')

    }
    else if (event.target.id === 'years') {


      //  if (retArray[0] === 'F') {
      //   SetDialogType('free-register')
      //   SetInfoBoxVisible(true);
      //   return;
      // }



      SetOppTableYears(event.target.value)
      SetOppTablePartialYears(-1) // (1) this is to force render only after new partial year is established.  fixed the lockup bug 8/22/2021
    }
    else if (event.target.id === 'partialYears') {
      SetOppTablePartialYears(event.target.value)

    }
    else if (event.target.id === 'day') {  // 4/30/2022 - changed day of the month to a pull down

      if (loggedinUser === '0') {
        SetDialogType('free-register')
        SetInfoBoxVisible(true);
        return;
      }

      let retArray = userAccessToSelectedSecurity(securityTypeList2, selectedSecurity)
      // the returned array consists of 3 items  
      // [0] = access type for selected security: 'F' or 'P'
      // [1] = premium access count
      // [2] = free access count
      if (retArray[0] === 'F') {
        SetDialogType('free-register')
        SetInfoBoxVisible(true);
        return;
      }

      // console.log('----------------x------------------------------',securityTypeList2)
      // console.log('selected_security=',selectedSecurity)


      SetDayOfTheMonth(event.target.value)



    }
    else if (event.target.id === 'filter') {

      if (showActiveOpps == false) { // no % filtering for active opps
        SetAppliedFilter(event.target.value)
        if (event.target.value !== 'no filter') {
          setShowMFE(true)
        }
      }
      else {
        SetDialogType('info-box');
        SetDialogProp({ title: 'Active Opportunities', contentText: 'Cannot Filter Active Opportunities!', button1Text: '', button2Text: 'Close', coverDivColor: 'rgb(222,222,222,0)' })
        SetInfoBoxVisible(true)
      }
    }


    else if (event.target.id === 'securityTypeList') {



      // show message to non-loggedin users to register to get more data 
      if (event.target.value.includes('More..')) {
        SetDialogType('register');
        SetInfoBoxVisible(true)
      }

      else {


        SetShowActiveOpps(false); // 5/2/2024

        console.log('setSelectedSecurity=', event.target.value);
        console.log('..................', securities_groups_default_years);

        // y1 and y2 are default number of years set in common for this securities group 11/19/2022


        // check if key exist first:

        let [y1, y2] = [10, 10]; // default years and probability years

        // there maybe an override for any specific securities group in Common.js
        if (event.target.value in securities_groups_default_years) {
          [y1, y2] = securities_groups_default_years[event.target.value];
        }





        // console.log('y1,y2=',y1,y2)
        // console.log('sssssssssssssssssselect box changed setting selectedSecurity to ', event.target.value)
        SetSelectedSecurity(event.target.value)
        let retArray = userAccessToSelectedSecurity(securityTypeList2, event.target.value)

        SetOppTableYears(-1)        // force reset of the selected year
        SetOppTablePartialYears(-1) // force reset of partial years
        SetYearsMetaData([])
        SetOppTableYears(-1) // -1 forces initializing #years when new security type is selected/loaded
        SetConsolidatedSeasonalData([])



        // if selected security is Free, change the oppTable date to today

        if (retArray[0] === 'F') {
          var today = new Date();

          // var isLeapDay = today.getMonth() === 1 && today.getDate() === 29;

          SetOppTableMonth(monthsOptionsList[today.getMonth()]['value'])
          dayOfMonthList(monthsOptionsList[today.getMonth()]['value'])  // 4/30/2022 - this is to create day of the month selectbox for opptable
          SetDayOfTheMonth(String(today.getDate()))
        }


        SetOppTableYears(y1.toString())
        SetOppTablePartialYears(y2.toString())


        setCookie('selectedSecurity', event.target.value, 300)

        SetLastPrice(['', 0])
        SetSymbol('')
        SetSeasonalBarChartData([])
        SetLineChartYear(0)

      }



    }
    SetOpportunities([]) //clear opportunties table becaues there will be a new fetch

  }

  //---------------------------------------------------------------

  const chartProps = {
    startDate,
    symbol,
    company,
    daysOut,
    seasonalYears,
    showMFE,
    showMAE,
    barChartLongOrShort,
    lineChartYear,
    tradeActive,
    monthsAndQtrs,
    securityTypeList,
    selectedSecurity,
    opportunities,
    oppTableMonth,
    oppTableYears,
    oppTablePartialYears,
    appliedFilter,
    rowIndexClicked,
    seasonalBarChartData,
    tradeDetailData,
    dayOfTheMonth,
    statBoxCoordinates,
    loggedinUser,
    infoBoxVisible,
    helpBoxVisible,
    tradeDate0,
    tradeDate1,
    dialogType,
    swiper,
    dialogProp,
    allowedSymbols,
    tooltipSW,
    yearsMetaData,

    resourceObj,  //4/12/2022 - this is all resources object obtained by calling getResourcesObj API
    userFreeResources, //4/12/2022 - list of users free resource
    userPremResources, //4/12/2022 - list of users prem resource
    securityTypeList2,

    daysOfMonthList, // 4/30/2022 - switching day of the month to a pulldown
    stockScoreCurrent, // 5/17/2022 - true false - when false its historical
    exportImage, // 5/24/2022
    lastPrice, // 6/21/2022
    consolidatedSeasonalData, //7/17/2022
    janDecDateRange, // 8/6/2022
    oppTableLength, // 8/28/2022
    videosBoxVisible, // 9/14/2022
    reportsDashVisible, // 3/8/2023
    reportsList, // 3/10/2023
    numReportsCreated,
    numReportsAllowed,
    addGCVisible,
    googleCalendarDict,
    multiPortfolios,    // true or false - switches multi portfolio capability 
    showPortfolioSettings,
    showSettings,
    portfolios,
    selectedPortfolio,
    selectedPortfolioID,
    numPortfoliosAllowed,
    qparams,
    showOppNote,
    selectedNote,
    selectedDRID,
    selectedPortfolioRec,
    helpEmailDisplay,
    compareSecurity, // 9/9/2023
    compareSecurityBarChartData, // 9/9/2023
    compareSecurityTradeDetailData, // 9/9/2023
    compareSecurityLongOrShort, // 9/9/2023
    initialWindowNum, // 9/26/2023
    securityBHstats, // 10/9/2023  - this is for getting the buy and hold of the current security for display
    reverseDateSelected, // used to correctly set the initial date of the reversed consolidated seasonal chart
    trendChartStartDate,
    trimYear, // this is for setting the trim year (oldest year we want) for special years such as odd, even, PE, PE1 PE2 PE3
    autoTradePortfolioMonth, // this is for generating a portoflio for audo trading for the month selected

    showPopulatePortfolio,
    showAutoTrade,
    showTradeReport,
    showTradeInstrumentReport,
    tradeInstrumentReportDict,
    showSR2, // this is for the configuration that oppTable shows SR, AP, SR2 & AP2
    switchStreamingQuotes,
    switchStreamingAccount,
    activeOpportunities,
    showActiveOpps,
    upgradeMessage,
    promotionMessage,
    promotionCouponCode,
    showUpgradeBanner,
    promotionBackColor,
    showWatermark,
    downloadImageName,
    showChatbot,
    refreshKey
  }

  const chartSetProps = {
    SetStartDate,
    SetSymbol,
    SetCompany,
    SetDaysOut,
    SetSeasonalYears,
    setShowMFE,
    setShowMAE,
    SetBarChartLongOrShort,
    SetLineChartYear,
    SetTradeActive,
    SetMonthsAndQtrs,
    SetSecurityTypeList,
    SetSelectedSecurity,

    SetOpportunities,
    SetOppTableMonth,
    SetOppTableYears,
    SetOppTablePartialYears,
    selectboxChanged,
    SetAppliedFilter,
    SetRowIndexClicked,
    SetSeasonalBarChartData,
    SetTradeDetailData,
    SetDayOfTheMonth,

    dayIncrement,
    dayDecrement,

    handleEnterInc,
    handleBlurInc,
    handleDayChange,
    SetStatBoxCoordinates,
    SetLoggedinUser,
    SetInfoBoxVisible,
    SetHelpBoxVisible,
    SetTradeDate0,
    SetTradeDate1,
    SetDialogType,
    setSwiper,
    SetDialogProp,
    SetAllowedSymbols,
    SetTooltipSW,
    SetYearsMetaData,


    SetResourceObj,  //4/12/2022 - this is all resources object obtained by calling getResourcesObj API
    SetUserFreeResources,
    SetUserPremResources,
    SetSecurityTypeList2,

    SetDaysOfMonthList, // 4/30/2022  switcdhing day of the month to a
    dayOfMonthList,     // 4/30/2022
    SetStockScoreCurrent,   // true = current , false = historical
    SetExportImage, // 5/24/2022 - true of false to signal exporting the visible div as jpg or png
    SetLastPrice, // 6/21/2022
    SetConsolidatedSeasonalData, //7/17/2022
    SetJanDecDateRange, //8/6/2022
    SetOppTableLength, // 8/28/2022
    SetVideosBoxVisible, // 9/14/2022
    SetReportsDashVisible, // 3/8/2023
    SetReportsList, // 3/10/2023
    SetNumReportsCreated,
    SetNumReportsAllowed,
    SetAddGCVisible,       //3/25/2023
    SetGoogleCalendarDict,
    SetMultiPortfolios,
    SetShowPortfolioSettings,
    SetShowSettings,
    SetPortfolios,
    SetSelectedPortfolio,
    SetSelectedPortfolioID,
    SetNumPortfoliosAllowed,
    SetQparams,
    SetShowOppNote,
    SetSelectedNote,
    SetSelectedDRID,
    SetSelectedPortfolioRec,
    SetHelpEmailDisplay,
    SetCompareSecurity, // 9/9/2023
    SetCompareSecurityBarChartData,  // 9/9/2023
    SetCompareSecurityTradeDetailData, // 9/9/2023
    SetCompareSecurityLongOrShort,  // 9/9/2023
    SetInitialWindowNum, // 9/26/2023
    SetSecurityBHstats, // 10/9/2023  - this is for getting the buy and hold of the current security for display
    SetReverseDateSelected, // used to correctly set the initial date of the reversed consolidated seasonal chart
    SetTrendChartStartDate,
    SetToken,
    SetTrimYear,
    SetAutoTradePortfolioMonth,

    SetShowPopulatePortfolio,
    SetShowAutoTrade,
    SetShowTradeReport,
    SetShowTradeInstrumentReport,
    SetTradeInstrumentReportDict,
    SetShowSR2,
    SetSwitchStreamingQuotes,
    SetSwitchStreamingAccount,
    SetActiveOpportunities,
    SetShowActiveOpps,
    SetUpgradeMessage,
    SetPromotionMessage,
    SetPromotionCouponCode,
    SetShowUpgradeBanner,
    SetPromotionBackColor,
    SetShowWatermark,
    SetDownloadImageName,
    SetShowChatbot,
    SetRefreshKey
  }



  let resizeWindow = () => {
    // console.log('resize window width',browserW,window.innerWidth)
    // console.log('resize window Height',browserH,window.innerHeight)

    if (rdd.isMobile && browserH !== window.innerHeight && browserW === window.innerWidth) { // condition that search box is clicked and height is reduced but with is the same
      return;
    }

    SetBrowserH(window.innerHeight);
    SetBrowserW(window.innerWidth);


    // const [browserH, SetBrowserH] = useState(window.innerHeight)
    // const [browserW, SetBrowserW] = useState(window.innerWidth)

    var headerDivH = document.getElementById('main-header').clientHeight;
    //-- footer-bottom is the Id for the default footer - 
    // var footerDivH = document.getElementById('footer-bottom').clientHeight;

    var footerDivH = 30;
    if (!debug) {
      footerDivH = document.getElementsByClassName('et-l')[0].clientHeight // when using a custom footer
    }
    // console.log('heights=', window.innerHeight, headerDivH, footerDivH)

    setSeasonalAppDivH(window.innerHeight - headerDivH - footerDivH)
    if (rdd.isTablet) {
      if (window.innerHeight > window.innerWidth) setSeasonalAppDivH2(window.innerHeight); // don't show header and footer on portrait
      else setSeasonalAppDivH2(window.innerHeight - headerDivH - footerDivH); // show header and footer on landscape
    }
    else {
      setSeasonalAppDivH2(window.innerHeight)
    }



    // setSeasonalAppDivH2(window.innerHeight)

    var textsize = '0.9vw';
    var zoom = '1'; // zoom determines the size of the checkboxes
    var table_text_size = '1vw';
    var table_title_text_size = '1vw';
    var info_text_size = '1.1vw'



    if (rdd.isMobile && !rdd.isTablet && window.innerHeight > window.innerWidth) { // smartphone portrait
      textsize = '3.3vw'; zoom = '1'; table_text_size = '3.0vw'; table_title_text_size = '3.0vw'; info_text_size = '3.5vw';
    }
    else if (rdd.isMobile && !rdd.isTablet && window.innerHeight < window.innerWidth) { //smartphone landscape
      textsize = '2.0vw'; zoom = '1'; table_text_size = '2.0vw'; table_title_text_size = '2.0vw'; info_text_size = '2.2vw';
    }
    else if (rdd.isMobile && rdd.isTablet && window.innerHeight > window.innerWidth) { // tablet portrait
      if (window.innerWidth < 1024) {
        textsize = '1.7vw'; zoom = '1.2'; table_text_size = '3.1vw'; table_title_text_size = '2.8vw'; info_text_size = '1.8vw';
      }
      else {
        textsize = '2.0vw'; zoom = '2'; table_text_size = '2.8vw'; table_title_text_size = '2.8vw'; info_text_size = '1.8vw'; //tablet landscape
      }
    }
    else if (rdd.isMobile && rdd.isTablet && window.innerHeight < window.innerWidth) { //tablet landscape
      if (window.innerHeight < 1024) {
        textsize = '1.0vw'; zoom = '1.4'; table_text_size = '1.2vw'; table_title_text_size = '0.9vw'; info_text_size = '1.2vw';
      }
      else {
        textsize = '1.0vw'; zoom = '1.4'; table_text_size = '1.3vw'; table_title_text_size = '0.9vw'; info_text_size = '1.2vw';
      }
    }
    else if (!rdd.isMobile) {                                       // desktop
      textsize = '0.95em'; table_text_size = '0.9vw'; table_title_text_size = '0.8vw'; info_text_size = '0.9vw';

      // console.log('......................rdd=',rdd)

      if (rdd.isSafari) {
        // console.log('-------------############################### its safari')
        info_text_size = '0.60vw';
      }
      else {
        info_text_size = '0.85vw';
      }
    }

    SetGlobalTextSize(textsize);
    SetCheckboxZoom(zoom);
    SetTableTextSize(table_text_size);
    SetTableTitleTextSize(table_title_text_size);
    SetInfoTextSize(info_text_size);

  };

  //- end of resizeWindow() ----------------------------------------------------------------------------------------

  useLayoutEffect(() => {
    resizeWindow();
    window.addEventListener("resize", resizeWindow);
    return () => window.removeEventListener("resize", resizeWindow);
  })

  //-------------------------------------------------------------------------------
  // start login useeffect - login
  //-------------------------------------------------------------------------------
  useEffect(() => {
    let tmp_selected_security = '';
    var tmp = window.current_user_level;  // thsi is in wordpress page for /seasonals source



    // ###########################################################################
    // if (debug) (tmp = '1,2,4,6,')// set levels here during DEBUG.  :3000 won't work otherwise
    // if (debug) (tmp = '1,2,') // testing basic monthly - remove
    // if (debug) (tmp = '6,')


    console.log('window.current_user_level=', tmp)



    // ###########################################################################
    if (tmp.substr(-1) === ',') tmp = tmp.substring(0, tmp.length - 1);
    tmp = tmp.split(',')


    if (debug) tmp = [testUserLevel];  // this is for testing Free Ripple level only 

    // console.log('..................................................wpUserLevels=',tmp)

    SetWpUserLevels(tmp)


    if (tmp.length === 1 && tmp[0] === '1') { // get first and last day of the week
      var curr = new Date(); // get current date
      var curr2 = new Date();
      var first = curr.getDate() - curr.getDay(); // First day is the day of the month - the day of the week
      var last = first + 6; // last day is the first day + 6


      var d = new Date(curr.setDate(first))
      var d1 = d.getFullYear() + '-' + (d.getMonth() + 1 < 10 ? '0' : '') + (d.getMonth() + 1) + '-' + (d.getDate() < 10 ? '0' : '') + d.getDate()
      d = new Date(curr2.setDate(last))
      var d2 = d.getFullYear() + '-' + (d.getMonth() + 1 < 10 ? '0' : '') + (d.getMonth() + 1) + '-' + (d.getDate() < 10 ? '0' : '') + d.getDate()
      SetUserDateRange([d1, d2])
    }
    else SetUserDateRange([])

    // get wp userid and token from cookie that was set by wordpress
    var userid = '0';
    var loginToken = 'no token';
    var cookie = getCookie('apsl');
    // if (debug) console.log('cookie=', cookie)

    if (cookie === null) {
      console.log('missing cookie "apsl"')
    }
    else {
      userid = cookie.split(',')[0];

      // if (debug) userid = '1'; // this is Tidal Yearly 
      // if (debug) userid = '19'; // this is free Ripple 
      if (debug) userid = testUserID; // this is for testing Free Ripple level only
      // if (debug) userid = '17'; // this is me - this is basic - 15 is premium

      // if (debug) userid = '16'; // this is me - this is free registered
      // if (debug) userid = '0'; // testing non loggedin user

      loginToken = cookie.split(',')[1];

      // if (debug) loginToken = "b3976554cdd244e38c21d67f95dc0862"; // some reason port 3000 cookie doesn't work anymore - this works
      if (debug) loginToken = process.env.REACT_APP_DEBUG_LOGIN_TOKEN

      // console.log('ddddddddddddddddddddebug loginToken=',loginToken,userid)
      // as long as generate_key in crontab does not run 
      // this only works on dev

      SetLoggedinUser(userid)
      if (userid === '0') {
        SetOppTableYears(freeYears[0].toString())  // set to 8 or 10 
        SetOppTablePartialYears(freeYears[1].toString())
      }
      else {
        if (tmp_selected_security === '') {
          tmp_selected_security = getCookie('selectedSecurity')

          if (tmp_selected_security === null) {

            // tmp_selected_security = securityTypeList[startingSecurity];
            tmp_selected_security = startingSecurityName;
          }

        }

        // console.log('.......................tmp_selected_security=',tmp_selected_security)

        if (wpUserLevels.length === 1 && wpUserLevels[0] === '1') { //free registered

          // assign the years and partial years from the lookup table on common 11/22/2022
          let [y1, y2] = [10, 10]; // start with default first
          if (tmp_selected_security in securities_groups_default_years) { // if there is an override in Common.js set it to that
            [y1, y2] = securities_groups_default_years[tmp_selected_security];
          }


          SetOppTableYears(y1.toString())
          SetOppTablePartialYears(y2.toString())
        }
        else { // all paid registered users
          // console.log('...................................tmp_selected_security=',tmp_selected_security)

          let [y1, y2] = [10, 10]; // start with default first
          if (tmp_selected_security in securities_groups_default_years) { // if there is an override in Common.js set it to that
            [y1, y2] = securities_groups_default_years[tmp_selected_security];
          }
          SetOppTableYears(y1.toString())
          SetOppTablePartialYears(y2.toString())
        }



      }
    }

    // console.log('tttttttttttttttttttttttttttttttttttoken=',token)

    // this useEffect comes through twice, early mistake and react basics
    // second time, token is already establsihed, so we don't login again
    // if (true){
    // if (token && token.length === 0) {  // if token already obtained, this is the second pass, don't need to login again
    if (!token || token.length === 0){  // 5/9/2025 - dev stopped working - I think the above line was the reason.  changed it to this
      let asURL = appserverURL()

      let deviceType = '!';
      let deviceOS = '!';
      if (rdd.isDesktop) {
        deviceType = 'D'
        if (rdd.isMacOs) deviceOS = 'M';
        else if (rdd.isWindows) deviceOS = 'W';
        else if (rdd.osName === 'Linux') deviceOS = 'L'
        else deviceOS = rdd.osName
      }
      if (rdd.isTablet) {
        deviceType = 'T';
        if (rdd.isAndroid) deviceOS = 'A';
        else if (rdd.isIOS) deviceOS = 'I';
        else if (rdd.osName === 'Linux') deviceOS = 'L'
        else deviceOS = rdd.osName
      }
      if (!rdd.isTablet && rdd.isMobile) { //smartphone
        deviceType = 'S';
        if (rdd.isAndroid) deviceOS = 'A';
        else if (rdd.isIOS) deviceOS = 'I';
        else if (rdd.osName === 'Linux') deviceOS = 'L';
        else if (rdd.isWindows) deviceOS = 'W';
      }

      tmp = window.current_user_level;

      //#######################################################################  need fixing ##########
      if (tmp === '') tmp = '6'  // passing the user_level from the React to appserver here during login

      var numbers = tmp.split(",").map(Number); // convert array of strings to array of numbers
      var largestNumber = Math.max(...numbers); // find largest number in the array
      tmp = largestNumber.toString();

      if (window.current_user_level === '2,1,4,') tmp = '6' // this is a weird one - for admin I have to fix it in worpdress where userlevel is passed 


      // settig user level for debug when free ripple user 
      if (debug) tmp = testUserLevel; // this is for testing Free Ripple level only 

      //#######################################################################

      

      let url = `${asURL}/login/${userid}/${tmp}/${deviceType}/${deviceOS}/${loginToken}`
      console.log('llllllllllllllllllllllllllllllllllllllllllllllllllllllllllllllllloging=',url)
      

      if (debug) console.log('login url =', url)

      // console.log('login url=',url)

      var stat = ''
      // login to appserver
      fetch(url)
        .then(res => {

          const contentType = res.headers.get("content-type");

          // console.log('res fetch returned:', res.status, res.statusText, contentType)

          if (contentType && contentType.indexOf("application/json") !== -1) {
            stat = 'OK'
            return res.json();
          }
          else if (res.status === 429) { // too many requests
            stat = 'rate-limit'
            // let trigger = res.headers["trigger"];
            // SetDialogType('info-box'); //429
            SetDialogType('rate-limit'); //429
            // SetDialogProp({ title: 'Too Many Requests', contentText: ratelimitMessage(trigger, loggedinUser), button1Text: '', button2Text: 'Close', coverDivColor: 'rgb(222,222,222,0)' })
            SetInfoBoxVisible(true)
          }
          else {
            stat = 'unreachable'
            SetDialogType('info-box');
            SetDialogProp({ title: 'App Server Unreachable', contentText: 'Cannot communicate with the application server.  Try refreshing the browser or try accessing the Wave Viewer later. returned message:a-' + res.status, button1Text: '', button2Text: 'Close', coverDivColor: 'rgb(222,222,222,0)' })
            SetInfoBoxVisible(true)
          }

          // throw new Error('Network response was not ok.');
        })

        .then((t) => {
          SetToken(t['token']) //token is for flask and is passed with usecontext
        })
        .catch(err => {
          // console.log('stat=', stat)
          // console.log('catch login error=', err.message)
          if (stat === '') { // if stat is blank, rate-limit is not the reason for failure - its because appserver is not running or erroed out
            SetDialogType('info-box');
            let content = 'Cannot communicate with the application server.  Try refreshing the browser or try accessing Wave Viewer later.'
            if (err.message.includes('token')) content += 'status:T404';
            else if (err.message.includes('fetch')) content += 'status:A502';
            else content += 'message:' + err.message;
            SetDialogProp({ title: 'App Server Unreachable', contentText: content, button1Text: '', button2Text: 'Close', coverDivColor: 'rgb(222,222,222,0)' })
            SetInfoBoxVisible(true)
          }
        })

    }

    // console.log('token=', token)

    if (token.length > 0) {

      var decoded = jwt_decode(token);
      // let show_sr2_token = decoded['show_sr2'];
      // if (show_sr2_token === 1){
      //   SetShowSR2(true);
      // }
      // console.log("decoded['resource_disp']=", decoded)
      // these are the web reports that user can and has created already used for restricting too many
      SetNumReportsAllowed(decoded['num_reports_allowed']);
      SetNumReportsCreated(decoded['num_reports_created']); // when logging in - the initial number created is loaded here
      SetNumPortfoliosAllowed(decoded['num_portfolios_allowed']);




      if (decoded['upgrade_message']) {
        SetUpgradeMessage(decoded['upgrade_message']);
      }

      if (decoded['promotion_message']) {
        SetPromotionMessage(decoded['promotion_message']);
      }

      if (decoded['promotion_coupon_code']) {
        SetPromotionCouponCode(decoded['promotion_coupon_code']);
      }

      if (decoded['promotion_back_color']) {
        SetPromotionBackColor(decoded['promotion_back_color']);
      }

      if (decoded['upgrade_message'] !== '') {
        SetShowUpgradeBanner(true)
      }


      // get resources list for this user from the token 
      tmp = [];

      for (var i = 0; i < decoded['resource_disp'].length; i++) {
        tmp.push({ id: i, value: decoded['resource_disp'][i], label: decoded['resource_disp'][i] });
      }

      // add more ... to the bottom of the list for non logged-in users
      if (loggedinUser === '0') {
        tmp.push({ id: i + 1, value: 'More...', label: 'More...' })
      }

      SetSecurityTypeList(tmp) // securities type list for selection  

      if (userid === '0') {

        // this one sets the financial groups as s&p500
        tmp_selected_security = tmp[startingSecurity].value; // startingSecurity is the number on the list of securities for initial selected security
        // used to be 0 for dow 30 now we can set it on Common - trying s&p which is 2 11/18/2022

        if (!debug) {

          // for non logged-in users show the terms dialogbox once a day only 

          let ta = getCookie('terms_accepted')

          if (ta == null || ta !== userid) {
            SetDialogType('terms-conditions')
            SetInfoBoxVisible(true); // show the dialog for terms and conditions
            setCookie('terms_accepted', userid, 1)
          }

          // SetDialogType('terms-conditions')
          // SetInfoBoxVisible(true); // show the dialog for terms and conditions

        }

      }
      else {

        // for every person that is logged-in show terms popup once and save it in a cookie so it won't show again
        let ta = getCookie('terms_accepted')

        if (ta == null || ta !== userid) {
          SetDialogType('terms-conditions')
          SetInfoBoxVisible(true); // show the dialog for terms and conditions
          setCookie('terms_accepted', userid, 365)
        }


        // tmp_selected_security = getCookie('selectedSecurity')

        // if (tmp_selected_security == null) {
        //   tmp_selected_security = tmp[0].value; // when no cookie set it to the first one of the list
        // }

      }


      // console.log('.........................................tmp_selected_security=', tmp_selected_security)


      // console.log('ccccccccccccccccccccookie setting selectedSecurity ', tmp_selected_security)
      if (tmp_selected_security !== '') {
        SetSelectedSecurity(tmp_selected_security) // pull down on the top left s&p dji commodities ...
      }
      let retArray = userAccessToSelectedSecurity(securityTypeList2, selectedSecurity)
      // console.log('.................securityTypeList2, selectedSecurity=', securityTypeList2, selectedSecurity)
      SetSelectedSecurityType(retArray[0]) // 'F' or 'P'  free or premium
      // console.log('rrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrretarray[0]=',retArray[0])

    }
  }, [token, loggedinUser])
  //-------- end of login useEffect
  //---------------------------------------------------------------------------------
  // this useEffect will display the settings dialog the first time user logs in
  // then create a cookie to supress opening the dialog box next time
  // dialog box will open 2 seconds after login 
  // cookie name is called email_settings
  //---------------------------------------------------------------------------------

  // commented it out because now wordpress registration talks to mailerlite so we don't need to force this 9/6/2023

  // useEffect(() => {

  //   if (loggedinUser != '0') {
  //     let settings_cookie = getCookie('email_settings')
  //     if (settings_cookie === null) {

  //       setCookie('email_settings', loggedinUser, 365)

  //       const timeout = setTimeout(() => {
  //         SetShowSettings(true);
  //         SetHelpEmailDisplay('block'); // first time also show the settings help

  //       }, 2000); // display the settings window after 2 seconds - gives time for SV to load

  //     }
  //   }

  // }, [loggedinUser])
  //---------------------------------------------------------------------------------


  //---------------------------------------------------------------------------------
  // get resources from appserver  4/12/2022
  // this is the create SetSecurityTypeList2 which is the new format
  //---------------------------------------------------------------------------------
  useEffect(() => {

    let asURL = appserverURL()
    let url = `${asURL}/getResourcesObj?token=${token}`

    if (token && token.length > 0) {
      fetch(url)
        .then((res) => {
          return res.json();
        })
        .then((g) => {


          SetResourceObj(g['resources']) // added on 3/9/2023

          // console.log('rrrrrrrrrrrrrrrrrrrrr',typeof(g['resources']),g['resources'])


          let resourcesObj = g['resources']
          let freeObj = g['free']
          let premObj = g['prem']
          let nonlog = g['nonloggedin-resources'] // this is a list not an object

          let userFree = [];
          let userPrem = [];

          // console.log('g["free"]=', freeObj)
          // console.log('g["prem"]=', premObj)


          // console.log('wpUserLevels=', wpUserLevels)

          if (loggedinUser === 0) {
            userFree = nonlog; // set userFree list to the non loggedin resource list from server
          }
          else { // create userFree and userPrem list based on their access level
            for (let i = 0; i < wpUserLevels.length; i++) {
              if (freeObj[wpUserLevels[i]] !== undefined) userFree.push(...freeObj[wpUserLevels[i]]) //extending userFree with freeObj[i] list
              if (premObj[wpUserLevels[i]] !== undefined) userPrem.push(...premObj[wpUserLevels[i]])
            }
          }
          // get rid of duplicates in userFree and userPrem
          userFree = [...new Set(userFree)]
          userPrem = [...new Set(userPrem)]



          // remove items from userFree that are in userPrem
          userFree = userFree.filter((userFree) => !userPrem.includes(userFree));


          // console.log('111111111111111111 userFree=',userFree)
          // console.log('222222222222222222 userPrem=',userPrem)


          // console.log('resourcesObj=', resourcesObj)
          // now create a list of objects for the user based on free and prem 
          var tmp = []
          for (var i = 0; i < userPrem.length; i++) {
            tmp.push({ id: i, value: userPrem[i], label: resourcesObj[userPrem[i]], type: 'P' })
          }
          for (var j = 0; j < userFree.length; j++) {
            tmp.push({ id: i + j, value: userFree[j], label: resourcesObj[userFree[j]], type: 'F' })
          }
          if (loggedinUser === 0) {
            tmp.push({ id: i + j + 1, value: '', label: 'More...', type: '' })
          }


          // console.log('ttttttttttttttttttttmp=',tmp)

          SetSecurityTypeList2(tmp)
        })
        .catch(err => {
          console.log('getResourcesObj error=', err.message)
        })


    }


  }, [token, loggedinUser])


  //-------------------------------------------------------------------------------
  // Allowed Symbols after token is obtained
  //-------------------------------------------------------------------------------
  useEffect(() => {

    //-------------------------------------------------------------------------------------------------------------
    // for some reason I don't know, when the selected security is one of the non US stocks, the selectedSecurity
    // variable become blank after refreshing the browser.  I don't know why but it caused problems loading
    // the correct allowedSymbols to determine the company name.  to fix this I added a condition to only
    // load allowedSymbols, if selectedSecurity.length > 0 to prevent this rogue loading of the wrong list
    // I don't know why its happending but adding this condition seems to fix the problem  8/19/2023
    //-------------------------------------------------------------------------------------------------------------
    if (selectedSecurity.length > 0) {
      let id = getSelectedIDFromSecuritiesList2(securityTypeList, selectedSecurity)

      // console.log('iiiiiiiiiiiiiiiiiid ,securityTypeList, selectedSecurity = ', id, securityTypeList, selectedSecurity)

      let asURL = appserverURL()
      let url = `${asURL}/GetListSymbols/${id}?token=${token}`
      // console.log('^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^GetListSymbols url =', url)
      // console.log('....................................setting SR2 to ',showSR2)

      // SetAllowedSymbols
      if (token.length > 0) {
        fetch(url)
          .then((res) => {
            // console.log('--------------------------------------------------fetch allowed symbols')
            return res.json();
          })
          .then((g) => {
            // console.log('set allowed symbols is called with selectedSecurity=', selectedSecurity)
            // console.log('1111111111111111111111111set allowed symbols in main useEffect', selectedSecurity)
            console.log('...the allowedsymbols are set to', g['AllowedSymbols'])
            SetAllowedSymbols(g['AllowedSymbols'])
            console.log('selectedSecurity,len allowed symbols,allowedSymbols list=', typeof (g['AllowedSymbols']), "g['AllowedSymbols']=", g['AllowedSymbols'])

          })
          .catch(err => {
            console.log('eeeeeeeeeeeeeeeeGetListSymbols error=', err.message)
          })
      }
    }
  }, [token, selectedSecurity])


  //-------------------------------------------------------------------------------
  // capture the query string parameters
  //-------------------------------------------------------------------------------
  useEffect(() => {
    // <a target='_blank' href='{domain_root}seasonals?fg={financial_group_id}&s={symbol}&d={date1}&dh={days_hold}&y={history_years}'>Seasonal Viewer</a>


    let queryString = window.location.search;

    if (queryString.length > 0) {
      // console.log('qs=', queryString, window.current_user_id)

      if (queryString === '?set=on') { // with this querystring when tradewave-viewer is envoked, it automatically open settings window
        // console.log('display the settings windows')
        // remove the querystring 
        window.history.replaceState(null, '', window.location.href.split('?')[0]);
        // turn on the settings window


        if (window.current_user_id == '0') { // userid 0 has to login to before can  get the settings window opened
          // console.log('userid =', window.current_user_id, loggedinUser)

          window.location.href = '/member-login';
        }
        else {
          const timeout = setTimeout(() => {
            //     SetShowSettings(true);
          }, 1000); // display the settings window after 2 seconds - gives time for SV to load
        }
      }

      else {
        SetQparams(queryString)

        let urlParams = new URLSearchParams(queryString);
        let b64 = urlParams.get('o');
        // console.log('b64=',b64);

        let param_str = window.atob(b64)
        // console.log('decoded=',param_str)

        let params = param_str.split('|')

        // console.log('.........................................params=',params)

        // the reason for opportunities.length > 0 is that there was a timing issue - pull down would change but
        // kept the old list - by checking opportunities.length > 0 - its delaying the update until other things are 
        // loaded and ready

        if (token && b64 !== null && token.length > 0 && Object.keys(resourceObj).length > 0 && queryString.length > 0 && opportunities.length > 0) {
          // let urlParams = new URLSearchParams(queryString);
          let fg_id = params[0];
          let resource_group = resourceObj[parseInt(fg_id)]
          let symbol = params[1];
          let date1 = params[2];
          let days_hold = params[3];
          let history_years = params[4].toLowerCase(); // tolowercase is because reports pass PE1 PE2  ..  app recognizes pe1 pe2 ..


          // console.log('rrrrrrrrrrrrrrrrrrrrrrrrrrresource_group=',resource_group)

          if (fg_id === null || resource_group === null || symbol === null || date1 === null || days_hold === null || history_years === null) {
            return
          }



          SetStartDate(date1)
          SetSymbol(symbol)
          SetDaysOut(days_hold)
          SetSeasonalYears(history_years)
          SetMonthsAndQtrs('Months & Qtrs')
          SetConsolidatedSeasonalData([]) //2022-09-27





          let trend_chart_start_date = incrementDate(date1, -trend_chart_left_gap_days); // set to 2 weeks before  - set in common 
          SetTrendChartStartDate(trend_chart_start_date)

          // console.log('qqqqqqqqqqqqqqqqqqquery string setting selectedSecurity to ', resource_group)
          SetSelectedSecurity(resource_group)

          let [y1, y2] = securities_groups_default_years[resource_group]; // these are defined as default in common.js

          // console.log('hhhhhhhhhhhhhhhistory_years', typeof (history_years), typeof (y1))

          const timer = setTimeout(() => {
            SetOppTableYears(history_years) // removed then readded with timer on 3/27/2025 - 
          }, 1000); // 1000ms = 1s delay



          if (parseInt(history_years) === y1) {
            SetOppTablePartialYears(y2.toString())
          }
          else {
            SetOppTablePartialYears(-1) // -1 defaults the partial years to the first one on the list
          }
          SetOpportunities([])


          // if (rdd.isMobile && !rdd.isTablet && browserH < browserW) {
          if (!rdd.isMobile) {
            // console.log('qqqqqqqqqqqqqqqqqqqqq');
            setCookie('WindowNumber', '2', 300)
          }

          // clear the querystring
          // Replace the current URL with the same URL without the query string
          window.history.replaceState(null, '', window.location.href.split('?')[0]);
        }
      }
    }

  }, [token, Object.keys(resourceObj).length, opportunities.length])


  useEffect(() => {
    // console.log('************************************************', token.length > 0, symbol.length > 0, Object.keys(allowedSymbols).length > 0, allowedSymbols[Object.keys(allowedSymbols)[20]])
    if (token && token.length > 0 && symbol.length > 0 && Object.keys(allowedSymbols).length > 0) {
      // console.log(allowedSymbols)
      // console.log('company for ticker ', symbol, ' is', allowedSymbols[symbol])
      SetCompany(allowedSymbols[symbol])
      // console.log('symbol,allowedSymbols.length,allowedSymbols[symbol]=', symbol, allowedSymbols.length, allowedSymbols[symbol])
    }
    else {
      SetCompany('');
    }

  }, [symbol, token, allowedSymbols])
  //------------------------------------------------------------------------------------------------------------------------------------------------------
  // refresh when mobile orientation changes
  //------------------------------------------------------------------------------------------------------------------------------------------------------
  const refreshPage = () => {
    window.location.reload();
  };
  //------------------------------------------------------------------------------------------------------------------------------------------------------
  // Add an event listener for the 'orientationchange' event and call the refreshPage function when it occurs.
  useEffect(() => {
    window.addEventListener('orientationchange', refreshPage);

    // Clean up the event listener when the component unmounts.
    return () => {
      window.removeEventListener('orientationchange', refreshPage);
    };
  }, []);
  //------------------------------------------------------------------------------------------------------------------------------------------------------
  return (

    <>
      <UserContext.Provider value={{ selectedSecurityType, resourceObj, debug, wpUserLevels, seasonalAppDivH, seasonalAppDivH2, browserH, browserW, rdd, token, globalTextSize, checkboxZoom, tableTextSize, tableTitleTextSize, infoTextSize, loggedinUser }} >
        {/* had to add test !rdd.isMobile only for safari on ipad */}
        <BrowserView>
          {
            !rdd.isMobile
            &&
            <DesktopLayout {...chartProps} {...chartSetProps} />
          }
        </BrowserView>

        <MobileView>
          {
            rdd.isTablet && browserH < browserW
            &&
            <DesktopLayout {...chartProps} {...chartSetProps} />
          }
          {
            !rdd.isTablet && browserH < browserW
            &&
            <MobileLayoutL {...chartProps} {...chartSetProps} {...browserH} {...browserW} />
          }
          {
            browserH > browserW
            &&
            <MobileLayoutP {...chartProps} {...chartSetProps} {...browserH} {...browserW} />
          }
        </MobileView>
      </UserContext.Provider>
    </>

  );
}

export default App;
